/*
 * Copyright (c) 2019 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained herein is, and remains
 * the property of Indigen Solutions and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */

export class UserApi {
    constructor(api) {
        this.api = api;
    }

    async getMe() {
        try {
            const user = await this.api.get(`/user/me`);
            return user;
        } catch (e) {
            // TODO Handle access denied
            return null;
        }
    }

    async selectConvention(conventionId) {
        try {
            const user = await this.api.patch(`/user/me/selectConvention`, conventionId);
            return user;
        } catch (e) {
            return null;
        }
    }

    async removeConvention(conventionId) {
        try {
            const user = await this.api.patch(`/user/me/removeConvention`, conventionId);
            return user;
        } catch (e) {
            return null;
        }
    }

    async updateConventionSubscription(selectedConvention) {
        try {
            const user = await this.api.patch(
                `/user/me/updateConventionSubscription`,
                selectedConvention
            );
            return user;
        } catch (e) {
            return null;
        }
    }

    async getMyConventions() {
        try {
            return await this.api.get(`/user/me/conventions`);
        } catch (e) {
            // TODO Handle access denied
            return null;
        }
    }

    async updateInfo(newUser) {
        try {
            const user = await this.api.patch(`/user/me/updateInfo`, newUser);
            return user;
        } catch (e) {
            // TODO Handle access denied
            return null;
        }
    }

    async updateNotifications(notifications) {
        return await this.api.patch(`/user/me/updateNotifications`, notifications);
    }

    async updatePassword(passwordRequest) {
        await this.api.patch(`/user/me/updatePassword`, passwordRequest);
    }

    async acceptCgu() {
        try {
            const user = await this.api.post(`/user/me/acceptCgu`, {});
            return user;
        } catch (e) {
            // TODO Handle access denied
            return null;
        }
    }

    clean() {
        this._me = null;
    }
}
